<ng-container *ngIf="(getState$ | async).isAuthenticated as isAuthenticated; else notAuthenticated">

  <ng-container *ngIf="(getState$ | async) as authState">

    <mat-toolbar class="p-0 mat-elevation-z1 w-100-p">

      <div id="toolbar.component" appFlexLayout="row" class="w-100-p">
        <ng-container *ngIf="!(fullSearchService.fullSearchState$|async).ux.barIsDisplayed">
          <app-references-title class="w-50-p"></app-references-title>

        </ng-container>



        <div appFlexLayout appFlexAlign="end center" class="w-100-p">
          <app-full-search *appIsClient></app-full-search>
          <div appFlex class="top-dxtoolbar-container">
            <dx-toolbar class="top-dxToolbar" #toolbar [multiline]="false">

              <dxi-item *appIfUserHas="['GOD_MODE']" location="center" widget="dxButton">
                <app-chat-box-button></app-chat-box-button>
              </dxi-item>
              <!--              <ng-container *appIfDebugMode="true">-->
              <!--                <dxi-item *appIfUserHas="['GOD_MODE']" location="center" widget="dxButton">-->
              <!--                  &lt;!&ndash;                    Must be deleted as soon as possible&ndash;&gt;-->
              <!--&lt;!&ndash;                  <app-toolbar-tool-popup></app-toolbar-tool-popup>&ndash;&gt;-->
              <!--                </dxi-item>-->
              <!--              </ng-container>-->


              <dxi-item location="center" widget="dxButton">
                <div *dxTemplate>
                  <app-update-info></app-update-info>
                </div>
              </dxi-item>

              <dxi-item *ngIf="userContext.userAccess.includes('GOD_MODE')" location="after" widget="dxButton"
                locateInMenu="auto" showText="inMenu" text="Debug">
                <button mat-icon-button (click)="switchDebugMode()">
                  <mat-icon class="secondary-text"
                    [svgIcon]="authState.uxInteractions.debugMode ? 'bug-check' : 'bug-check-outline'"></mat-icon>
                </button>
              </dxi-item>

              <dxi-item location="after" widget="dxButton" locateInMenu="never">
                <app-who-is-online></app-who-is-online>
              </dxi-item>

              <dxi-item *ngIf="userContext.userAccess.includes('GOD_MODE')" location="after" widget="dxButton"
                locateInMenu="auto" showText="inMenu" text="Workers">
                <div *dxTemplate>
                  <app-live-workers></app-live-workers>
                </div>
              </dxi-item>

              <dxi-item *ngIf="userContext.userAccess.includes('GOD_MODE')" location="after" widget="dxButton"
                locateInMenu="auto" showText="inMenu" text="Tree store">
                <button mat-icon-button (click)="displayStoreTreePopupService.display()">
                  <mat-icon class="secondary-text">forest</mat-icon>
                </button>
                <app-display-store-tree-popup
                  *ngIf="(displayStoreTreePopupService.displayTreePopup$|async)"></app-display-store-tree-popup>
              </dxi-item>

              <dxi-item *ngIf="userContext.userAccess.includes('GOD_MODE')" location="after" widget="dxButton"
                locateInMenu="auto" showText="inMenu" text="Tree store">
                <button mat-icon-button [routerLink]="['/internal/listSurveyDash']">
                  <mat-icon class="secondary-text">school</mat-icon>
                </button>
              </dxi-item>


            </dx-toolbar>
          </div>

          <div appFlexLayout appFlexAlign="end center" appFlex="noshrink" class="user-menu ml-24">

            <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
              <div appFlexLayout="row" appFlexAlign="center center">
                <img *ngIf="authState.user.context.media" class="avatar mr-8 mr-sm-16"
                  [src]="baseUrl+'/media/'+authState.user.context.media+'/h/40'">
                <mat-icon *ngIf="!authState.user.context.media" class="avatar mr-8 mr-sm-16">account_circle</mat-icon>
                <span class="username mr-12">{{ authState.user.context.displayName }}</span>
                <mat-icon class="s-16">keyboard_arrow_down</mat-icon>
              </div>
            </button>

            <div class="toolbar-separator"></div>
            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
              <button mat-menu-item [routerLink]="['/profile']">
                <mat-icon>account_circle</mat-icon>
                <span>{{ 'Mon profil'|translate }}</span>
              </button>
              <button mat-menu-item class="language-button" [matMenuTriggerFor]="languageMenu">
                <div appFlexLayout="row" appFlexAlign="center center">
                  <img class="flag flag-small mr-8" [src]="'assets/icons/flags/'+selectedLanguage?.flag+'.png'" alt="">
                  <div>{{ 'Langue' }}</div>
                  <span *ngIf="false" class="iso text-uppercase">{{ selectedLanguage?.id }}</span>
                </div>
              </button>
              <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
                <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
                  <span appFlexLayout="row" appFlexAlign="start center">
                    <img class="flag flag-small mr-16" [src]="'assets/icons/flags/'+lang.flag+'.png'">
                    <span class="iso ">{{ lang.title }}</span>
                  </span>
                </button>
              </mat-menu>
              <button mat-menu-item [matMenuTriggerFor]="keyOrLabel">
                <mat-icon *ngIf="authState.user.context.keyOrLabelDisplay === 'key'">vpn_key</mat-icon>
                <mat-icon *ngIf="authState.user.context.keyOrLabelDisplay !== 'key'">label</mat-icon>
                {{ 'Libellés' | translate }}
              </button>
              <mat-menu #keyOrLabel="matMenu">
                <button mat-menu-item (click)="setMode('key')">
                  <mat-icon>{{ authState.user.context.keyOrLabelDisplay === 'key' ? 'checked' : '' }}</mat-icon>
                  {{ 'Clé' | translate }}
                </button>
                <button mat-menu-item (click)="setMode('label')">
                  <mat-icon>{{ authState.user.context.keyOrLabelDisplay === 'label' ? 'checked' : '' }}</mat-icon>
                  {{ 'Libellés' | translate }}
                </button>
              </mat-menu>
              <button mat-menu-item class="" (click)="logOut()">
                <mat-icon>exit_to_app</mat-icon>
                <span translate="">Déconnexion</span>
              </button>
            </mat-menu>
          </div>

        </div>


      </div>
    </mat-toolbar>

  </ng-container>
</ng-container>

<ng-template #notAuthenticated>
  <mat-toolbar class="p-0 mat-elevation-z1">
    <div appFlex fxFill appFlexLayout="row" appFlexAlign="start center">
      <span appFlex></span>
      <div appFlex="1 0 auto" appFlexLayout="row" appFlexAlign="start center">
        <button mat-raised-button color="primary" [routerLink]="['/log-in']" mat-button>Login</button>
      </div>
    </div>
  </mat-toolbar>
</ng-template>